// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b67rt","field":"styles_field__3Kd3h","fieldCol":"styles_fieldCol__33KYn","diffCol":"styles_diffCol__2_lNA","diff":"styles_diff__rRPme"};